(function($, undefined) {
	'use strict';

	var showDescription = function() {
		var t = $(this);
		var com = t.closest('.board-of-directors-com');
		var desc = t.attr('data-description');
		var top = t.offset().top;
		var descCtn;
		var delay = 0;

		$('.board-director', com).each(function() {
			if ($(this).offset().top > top) {
				descCtn = $(this).prev();
				return false;
			} else if ($(this).index() === $('.board-of-directors-all-items-inner', com).children().length - 2) {
				descCtn = $(this).next();
			}
		});

		if ($('.board-director-desc-ctn.open', com).length > 0 && descCtn.attr('id') !== $('.board-director-desc-ctn.open', com).attr('id')) {
			delay = 500;
			$('.board-director.open', com).removeClass('open');
			$('.board-director-desc-ctn.open', com).slideUp(function() {
				$(this).find('.board-director-desc').html('');
				$(this).removeClass('open');
			});
		}

		setTimeout(function() {
			$('.board-director.open', com).removeClass('open');
			t.addClass('open');
			descCtn.find('.board-director-desc').html(desc);
			descCtn.slideDown(function() {
				$(this).addClass('open');
			});
		}, delay);
	};

	var hideDescription = function() {
		var descCtn = $('.board-director-desc-ctn.open');

		$('.board-director.open').removeClass('open');
		descCtn.slideUp(function() {
			$(this).find('.board-director-desc').html('');
			$(this).removeClass('open');
		});
	};

	var init = function() {
		$('.board-director.has-desc').click(showDescription);
		$('.close-board-director-desc-btn').click(hideDescription);

		$(window).resize(function() {
			if ($('.board-director-desc-ctn.open').length > 0) {
				hideDescription();
			}
		});
	};
	
	$(window).ready(init);

})(jQuery);

